import React from 'react';

const useFormContext = initialFormData => {
  const [formData, _setFormData] = React.useState(initialFormData || {});

  const setFormData = React.useCallback(
    (name, value) =>
      _setFormData(fd => ({ ...fd, [name]: value, dirty: true })),
    [_setFormData]
  );

  const formContext = React.useRef({
    updateForm: setFormData,
  });

  return {
    formContext,
    formData,
    setFormData,
  };
};

export { useFormContext };
